import React from "react";
import { useNavigate } from "react-router-dom";
import {
    ArrowRight,
    ChevronRight,
    Flame,
    Clock,
    BookOpen,
    Layout
} from "lucide-react";
import "./sm-dashboard-styles.scss";

const SmartExamDashboard: React.FC = () => {
    const navigate = useNavigate();

    const handleResume = () => {
        navigate("/sm_exam/practice");
    };

    return (
        <div className="sm-dashboard-container">
            <header className="sm-dash-header">
                <h1>Let's get to work. What are we crushing today?</h1>
                <div className="streak-badge">
                    <Flame size={14} className="streak-icon" />
                    <span>Streak 0 days</span>
                </div>
            </header>

            <section className="resume-section">
                <div className="section-title">
                    <h2>Resume Practice</h2>
                    <span className="count-badge">1</span>
                </div>

                <div className="resume-card" onClick={handleResume}>
                    <div className="card-content">
                        <h3 className="topic-title">Topic Drill</h3>
                        <p className="subject-name">Year 12 Chemistry</p>
                        <p className="timestamp">Started 2/24/2026</p>
                    </div>
                    <button className="play-button">
                        <ChevronRight size={24} />
                    </button>
                </div>
            </section>

            <div className="section-divider"></div>

            <section className="subjects-section">
                <div className="section-title">
                    <h2>Your Subjects</h2>
                </div>

                <div className="subjects-grid">
                    <div className="subject-card">
                        <h3>Year 12 Chemistry</h3>
                        <span className="subject-code">ATCHE</span>
                    </div>

                    <div className="subject-card">
                        <h3>Year 12 Methods</h3>
                        <span className="subject-code">ATMAM</span>
                    </div>

                    <div className="subject-card">
                        <h3>Year 12 Physics</h3>
                        <span className="subject-code">ATPHY</span>
                    </div>

                    <div className="subject-card">
                        <h3>Year 12 Specialist</h3>
                        <span className="subject-code">ATSPE</span>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default SmartExamDashboard;
